import React, { useEffect, useRef, useState, useContext } from "react"

import Layout from "../components/layouts/blank"
import Seo from "../components/seo"
import Headings from "../components/headings"

import logoWhite from "../assets/icons/logoWhite.svg"
import logoGoogle from "../assets/icons/logoGoogle.svg"
import axios from "axios"
import { graphql, navigate } from "gatsby"

// import Lottie from "react-lottie"
// import animationData from "../lotties/registerLoading.json"
import { useGoogleLogin } from "@react-oauth/google"
import { useLocation } from "@reach/router"
import { useDispatch } from "react-redux"
import { setAuthData } from "../state/actions/authAction"

import LocaleContext from "../context/Locale"

const RegisterPage = ({ context, data }) => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const queryParamValue = queryParams.get("email")

  const { activeLocale } = useContext(LocaleContext)
  const dispatch = useDispatch()
  const SITE_KEY = "6LeL9j4jAAAAAAyfZ57yGEMlaoEkxiA6Z06YSg1w"

  // const defaultOptions = {
  //   loop: true,
  //   autoplay: true,
  //   animationData: animationData,
  //   rendererSettings: {
  //     preserveAspectRatio: "xMidYMid slice",
  //   },
  // }

  const [formValue, setformValue] = React.useState({
    subdomain: "",
    name: "",
    company_name: "",
    email: "",
    phone: "",
    password: "",
    token: "",
  })

  const handleChange = (event) => {
    if (event.target.name === "subdomain") {
      setformValue({
        ...formValue,
        [event.target.name]: event.target.value.toLowerCase(),
      })
      return true
    }
    setformValue({
      ...formValue,
      [event.target.name]: event.target.value,
    })
  }
  React.useEffect(() => {
    if (queryParamValue) {
      setformValue({
        ...formValue,
        email: queryParamValue,
      })
    }
  }, [queryParamValue])

  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState(null)
  const [errors, setErrors] = useState({})

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id)

      if (!isScriptExist) {
        var script = document.createElement("script")
        script.type = "text/javascript"
        script.src = url
        script.id = id
        script.onload = function () {
          if (callback) callback()
        }
        document.body.appendChild(script)
      }

      if (isScriptExist && callback) callback()
    }

    // load the script by passing the URL
    loadScriptByURL(
      "recaptcha-key",
      `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`,
      function () {
        console.log("Script loaded!")
      }
    )
  }, [])

  const handleOnClick = (e) => {
    e.preventDefault()
    setLoading(true)
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(SITE_KEY, { action: "submit" })
        .then(async (token) => {
          setformValue({
            ...formValue,
            token: token,
          })
          await submitData(token)
        })
    })
  }

  const submitData = async (token) => {
    try {
      // make axios post request
      await axios({
        method: "post",
        url: "https://admin.rentalls.com/api/tenant/register",
        // url: "http://rentalls.test/api/tenant/register",
        data: { ...formValue, token: token },
        headers: { "Content-Type": "multipart/form-data" },
      })
      setLoading(false)
      navigate(`/${activeLocale}/thank-you/?subdomain=${formValue.subdomain}`)
    } catch (error) {
      setLoading(false)
      setResponse(error)
      setErrors(error.response.data.errors)
    }
  }

  const googleLogin = useGoogleLogin({
    flow: "implicit",
    onSuccess: async (codeResponse) => {
      const tokens = await axios
        .post("https://admin.rentalls.com/api/auth/google/callback", {
          code: codeResponse.access_token,
        })
        .then(function ({ data }) {
          dispatch(
            setAuthData({
              id: data.google_user.id,
              name: data.google_user.name,
              email: data.google_user.email,
              avatar: data.google_user.avatar,
            })
          )
          localStorage.setItem(
            "authData",
            JSON.stringify({
              id: data.google_user.id,
              name: data.google_user.name,
              email: data.google_user.email,
              avatar: data.google_user.avatar,
            })
          )
          navigate(`/${activeLocale}/auth/google`)
        })
    },
    onError: (errorResponse) => console.log(errorResponse),
  })

  return (
    <Layout data={data}>
      <Seo seo={{ metaTitle: "Register" }} />
      <div className="contentWrapper">
        <div className="innerContentWrapper">
          <div className="leftSide">
            <div className="lspFormWrapper">
              {loading && (
                <div className="lspForm">
                  {/* <Lottie options={defaultOptions} height={400} width={400} /> */}
                  <div className="signInText">
                    <span>
                      {
                        data?.strapi?.register?.data?.attributes
                          ?.preparingWorkflowLabel
                      }{" "}
                    </span>
                  </div>
                </div>
              )}

              <form
                style={{ display: loading ? "none" : "block" }}
                onSubmit={handleOnClick}
                action=""
                className="lspForm"
              >
                <div className="formHeader">
                  <h1 className="h1">
                    {
                      data?.strapi?.register?.data?.attributes
                        ?.registerPageLabel
                    }
                  </h1>
                  <p>
                    {data?.strapi?.register?.data?.attributes?.pageSubTitle}
                  </p>
                </div>
                <div className="formUpperRow">
                  {data?.strapi?.register?.data?.attributes?.oauth.map(
                    (btn) => {
                      return (
                        <a
                          onClick={() => googleLogin()}
                          className="btn btnGoogle d-block w-100"
                        >
                          <img
                            src={`https://cms.rentalls.com${btn?.icon?.data?.attributes?.url}`}
                            className="img-fluid"
                            alt="img description"
                          />
                          {btn.label}
                        </a>
                      )
                    }
                  )}
                </div>
                <div className="signInText">
                  <span>
                    {data?.strapi?.register?.data?.attributes?.manualSignupText}
                  </span>
                </div>
                <div className="mainForm">
                  {data?.strapi?.register?.data?.attributes?.registerForm?.map(
                    (formInput, key) => {
                      if (formInput.type === "checkbox")
                        return (
                          <div key={key} className="form-group checkboxRow">
                            <div className="fakeWrap">
                              <input
                                type="checkbox"
                                id="subscription-input"
                                className="form-control fakeInput"
                              />
                              <label
                                htmlFor="subscription-input"
                                className="fakeLabel"
                              >
                                {formInput.placeholder}
                              </label>
                            </div>
                          </div>
                        )
                      if (formInput.type === "text" && formInput.prependText)
                        return (
                          <div key={key} className="form-group">
                            <div className="input-group mb-3">
                              <input
                                onChange={handleChange}
                                value={formValue[formInput.name]}
                                type={formInput.type}
                                name={formInput.name}
                                style={{ textTransform: "lowercase" }}
                                className={`form-control ${
                                  errors[formInput.name] ? "is-invalid" : ""
                                }`}
                                placeholder={formInput.placeholder}
                              />

                              <div className="input-group-append">
                                <span
                                  className="input-group-text"
                                  id="basic-addon2"
                                >
                                  {formInput.prependText}
                                </span>
                              </div>
                              {errors[formInput.name] && (
                                <div className="invalid-feedback">
                                  {errors[formInput.name][0]}
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      return (
                        <div key={key} className="form-group">
                          <input
                            onChange={handleChange}
                            type={formInput.type}
                            name={formInput.name}
                            value={formValue[formInput.name]}
                            className={`form-control ${
                              errors[formInput.name] ? "is-invalid" : ""
                            }`}
                            placeholder={formInput.placeholder}
                          />
                          {errors[formInput.name] && (
                            <div className="invalid-feedback">
                              {errors[formInput.name][0]}
                            </div>
                          )}
                        </div>
                      )
                    }
                  )}

                  <div className="form-group text-center btnRow">
                    <button className="btn btnPrimary" disabled={loading}>
                      {loading
                        ? data?.strapi?.register?.data?.attributes
                            .submittingBtnLabel
                        : data?.strapi?.register?.data?.attributes
                            ?.submitBtnLabel}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="rightSide">
            <div className="logoWrap">
              <img src={logoWhite} className="img-fluid" alt="Rentalls" />
            </div>
            <span className="copyRightText d-none d-md-inline-block">
              All rights reserved &copy; 2022 <a href="/">Rentalls.</a>
            </span>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default RegisterPage

export const queryRegister = graphql`
  query fetchData($locale: STRAPI_I18NLocaleCode) {
    strapi {
      i18NLocales {
        data {
          attributes {
            code
            name
          }
        }
      }
      register(locale: $locale) {
        data {
          attributes {
            manualSignupText
            oauth {
              label
              icon {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
            pageSubTitle
            preparingWorkflowLabel
            registerPageLabel
            submitBtnLabel
            submittingBtnLabel
            registerForm {
              name
              placeholder
              prependText
              type
            }
          }
        }
      }
      global(locale: $locale) {
        data {
          attributes {
            topBar {
              text
            }
            languageTitle
            navbar {
              name
              links(filters: { disabled: { eq: false } }) {
                name
                link
              }
            }
          }
        }
      }
    }
  }
`
